import "../../../styles/stores/stockManagement/stockDetails.css";
import { createPortal } from "react-dom";
import { useState, useEffect, useRef } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { RiDeleteBin5Line } from "react-icons/ri";
import { HiPencil } from "react-icons/hi";
import { BsSearch, BsArrowRepeat, BsPercent, BsUpload, BsPhone, BsInfo, BsArrowBarLeft } from "react-icons/bs";
import GeneratBarcode from "../../../tools/BarcodeGenerator";
import DoughnutChart from "../../../components/charts/DoughnutChart";
import LineChartPD from "../../../components/charts/LineChartPD";
import AddSales from "./AddSales";
import { confirmPasswordUrl, createProductUrl, editProductUrl, uploadProductImageUrl } from "../../../api/endpoints";
import { useDispatch, useSelector } from "react-redux";
import AddDamages from "./AddDamages";
import { getAllData, saveData } from "../../../tools/indexdb";
import Spinner, { ButtonLoader } from "../../../components/uxCollections/Loaders";
import DeliverToggle, { ProductDeliverToggle } from "../../../components/toggleButton/DeliverToggle";
import { ColorTag, generateNumericId, listOfProductCategory, productUnit, ScannerWindow, SizeTag } from "./AddStockPage";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // 💅 includes default UI styling
import { BsUpcScan } from "react-icons/bs";

import JsBarcode from "jsbarcode";
import ImageCropper from "../../../components/imageCropper/ImageCropper";
import UploadImageWithPhone from "./UploadImageWithPhone/UploadImageWithPhone";
import WisheColor from "./ColorWish";
import Wishes from "./SelectSize";
import { setUser } from "../../../slice/webStoreUserSlice";
import Restock from "./Restock";
import { ProductHistory } from "./CheckStock";
import RestockOverlay from "./RestockNI";
import BarcodeScanner from "../makeTansaction/barCodeScanner/BarCodeScanner";
import { uiAlert } from "../../../components/alerts/customAlert/uiAlert";
import SubUnitOverlay from "./addingSubUnit/AddSubUnit";
import StockBreakdownOverlay from "./subUnitDetails/SubunitsDetails";
import { FaAngleRight } from "react-icons/fa";
import { ProductHistoryMain } from "../../notification/ProductdetailOverlay";
import { printProductLabels } from "../makeTansaction/TransactionSuccess";
import { truncateID } from "../makeTansaction/CashTransactionComp";
import { Move } from "lucide-react";
import { MoveProductOverlay } from "../warehouse/newInterface/WarehouseHouseN";
import { MoveProductFromStoreOverlay } from "./moveProduct/MoveproductFromStoreOverlay";

export const computeProductQuantity = (product) => {
  const baseQuantity = Number(product.quantity || 0);

  if (product.hasSubUnits && product.subUnits?.length > 0) {
    const subUnitsAsBase = product.subUnits.reduce((total, subUnit) => {
      const subUnitStock = Number(subUnit.quantityOfSubUnitInStock || 0);
      const conversionFactor = Number(subUnit.conversionFactor || 1);

      return total + Math.floor(subUnitStock / conversionFactor);
    }, 0);

    return Math.floor(baseQuantity + subUnitsAsBase);
  }

  return Math.floor(baseQuantity);
};

/* fetch the data use the product ID to display the relevant data */

/* update the imgaeCOunt with the length of image  */
const StockDetails = ({ product, changePage, setAlertDisplay, updateSelectedProduct, socket }) => {
  const [ImageCount, setImageCount] = useState(null);
  const [currentProduct, setCurrentProduct] = useState();
  const [loading, setLoading] = useState(true);
  const [openAddSales, setOpenAddSales] = useState(false);
  const [openAddDamage, setOpenAddDamage] = useState(false);
  const [productEditOrDelete, setProductEditOrDelete] = useState(null);
  const [chartData, setChartData] = useState(null);
  const [openConfirmPassword, setOpenConfirmPassword] = useState(false);
  const [openRestockModal, setOpenRestockModal] = useState(false);
  const [openViewHistory, setOpenViewHistory] = useState(false);
  const [addSubUnit, setAddSubUnit] = useState(false);
  const [viewSubUnit, setViewSubUnit] = useState(false);
  const { store } = useSelector((state) => state.store);
  const { user } = useSelector((state) => state.webStoreUser);
  const [productQuantity, setProductQuantity] = useState();
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [openMove, setOpenMove] = useState(false);

  useEffect(() => {
    setCurrentProduct(product);
    setImageCount(product.productImage ? product.productImage.length : 2);
    setLoading(false);
    setChartData(computeLineChartData(product.allSalesOffline));

    //check if product has subUnithasBeenUpdated to true

    const shouldAddSubUnit = (product.hasSubUnits && product.subUnits?.length === 0) || !product.subUnithasBeenUpdated;

    setAddSubUnit(shouldAddSubUnit);
    const computedQuantity = computeProductQuantity(product);
    console.log("computedQuantity", computedQuantity);

    setProductQuantity(computedQuantity);
  }, [product]);

  useEffect(() => {
    let ImgaeSlider = document.querySelector(".prodImagDivFlex");

    let count = 0;
    const interval = setInterval(() => {
      if (count < ImageCount) {
        ImgaeSlider.style.transform = `translateX(${-100 * count}%)`;
        count++;
      } else {
        ImgaeSlider.style.transform = `translateX(0%)`;
        count = 1;
      }
    }, 3000);
    return () => clearInterval(interval);
  }, [ImageCount]);

  const handleDelete = async () => {
    let accessToken = localStorage.getItem("accessToken");
    let storeID = store._id;
    let productID = product._id;

    try {
      let response = await fetch(createProductUrl + storeID, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ productID }),
      });
      if (response.ok) {
        uiAlert("product deleted successfully", "success");
        let storeProductCollection = await response.json();
        let storeData = await getAllData(store.storeName);

        if (storeData) {
          storeData.storeProductCollection = storeProductCollection.products;

          await saveData(store.storeName, storeData);

          changePage("stockManagement");
        }

        changePage("stockManagement");
      }
    } catch (error) {
      console.log(error);
    }
  };
  // in the future, this function will compute the line chart data based on all sales offline and online sales
  const computeLineChartData = (allSalesOffline) => {
    // allSalesOffline is an array of sales objects find the current year
    let currentYear = new Date().getFullYear();
    let currentYearSalesData = allSalesOffline.find((sale) => sale.year === currentYear);

    if (currentYearSalesData) {
      // reduce the data to create month lable, quantitiy data and salesPrice data [[], [], []]
      let chartData = currentYearSalesData.salesByMonth?.reduce(
        (acc, cur, i) => {
          acc[0].push(cur.month);
          acc[1].push(cur.quantity);
          acc[2].push(cur.salesPrice);
          return acc;
        },
        [[], [], []],
      );
      console.log("chartData", chartData);

      return chartData;
    }
  };
  const IconBack = () => (
    <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'>
      <polyline points='15 18 9 12 15 6' />
    </svg>
  );
  const IconPrint = () => (
    <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
      <polyline points='6 9 6 2 18 2 18 9' />
      <path d='M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2' />
      <rect x='6' y='14' width='12' height='8' />
    </svg>
  );
  const handlePrint = (qty) => {
    console.log(product);

    printProductLabels({
      product: {
        name: product.name || "Product Name",
        brand: product.brand || "Brand Name",
        barcode: product.scannedID || "123456789012",
        unitPrice: product.unitPrice ? product.unitPrice.toLocaleString() : "0",
        currency: user.userCountryCurrencySymbol || "$",
      },

      quantity: qty,

      labelHeightMm: 32,
      labelWidthMm: 70,
    });
  };

  return (
    <>
      {/* <IoIosArrowBack /> <p onClick={() => changePage("stockManagement")}>back</p> */}
      {/* <button className='pdp-back-btn' onClick={() => changePage("stockManagement")}>
        <IconBack /> back
      </button> */}
      <div className='pdp-topbar no-print'>
        <button className='pdp-back-btn' onClick={() => changePage("stockManagement")}>
          <IconBack /> back
        </button>
        <button className='pdp-print-btn' onClick={() => setShowPrintModal(true)}>
          <IconPrint /> Print Label
        </button>
      </div>

      <div className='stockdetailMainWrapper'>
        <div>
          <div className='productDetailDIv'>
            <div className='DeleteEditDivPD'>
              <RiDeleteBin5Line
                onClick={() => {
                  setProductEditOrDelete("delete");
                  setOpenConfirmPassword(true);
                }}
                size={20}
                color={"gray"}
                style={{ cursor: "pointer" }}
              />
              <div
                onClick={() => {
                  setProductEditOrDelete("edit");
                  setOpenConfirmPassword(true);
                }}
              >
                <HiPencil size={20} color={"gray"} style={{ cursor: "pointer" }} /> <p>Edit</p>
              </div>
            </div>

            <div className='productPictWrapper'>
              <div>
                <div className='prodImagDivFlex'>
                  {product.productImage?.map((image, index) => (
                    <img
                      key={index}
                      className='productImageTransform'
                      src={`${image.split("/upload/")[0]}/upload/f_auto,q_auto,w_196/${image.split("/upload/")[1]}`}
                    />
                  ))}
                </div>
              </div>
            </div>
            <div className='productNameAndRestockDIv'>
              <p className='productName'>{product.name}</p>
              <p>{product.productCategory}</p>
              <div className='restockDIvPD'>
                <div
                  className={product.hasSubUnits ? "hasSubunit22" : ""}
                  onClick={() => product.hasSubUnits && setViewSubUnit(true)}
                  style={{ position: "relative", cursor: "pointer" }}
                >
                  <b> {productQuantity} </b>
                  <p>in stock</p>

                  {product.hasSubUnits && product.subUnits.length > 0 && (
                    <span
                      style={{
                        position: "absolute",
                        top: "40%",
                        right: "10px",
                        bottom: "40%",

                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <FaAngleRight size={30} color='#8b6868' />
                    </span>
                  )}
                  <span></span>
                  {product.hasSubUnits && product.subUnits.length && <div className='sbo-tap-hint'>i</div>}
                </div>

                <div onClick={() => setOpenRestockModal(true)} className='restockBtnDivPD'>
                  <BsArrowRepeat style={{ cursor: "pointer" }} color='#5B79FF' size={20} />
                </div>
              </div>
            </div>
            <p style={{ fontSize: "0.9rem", fontWeight: "700" }}>Product details</p>
            <div className='productDetailInfo'>
              <div>
                {/*  <p>Store ID</p> */}
                <p>Product ID</p>
                <p>Limit</p>
                <p>Delivery fee</p>
                <p>Cost price</p>
                <p>Unit price</p>
                <p>Total worth </p>
              </div>
              <div>
                {/*  <p>{product.storeID}</p> */}
                <p>{truncateID(product._id)}</p>
                <p>{product.stockLimit}</p>
                <p>
                  {" "}
                  {user.userCountryCurrencySymbol} {product.deliveryFee ? product.deliveryFee.toLocaleString() : "N/a"}
                </p>
                <p>
                  {" "}
                  {user.userCountryCurrencySymbol} {product.costPrice.toLocaleString()}
                </p>
                <p>
                  {user.userCountryCurrencySymbol} {product.unitPrice.toLocaleString()}
                </p>
                <p>
                  {user.userCountryCurrencySymbol} {product.totalWorth.toLocaleString()}
                </p>
              </div>
            </div>
            <div className='AddSalesandDamsgeDiv'>
              <button onClick={() => setOpenAddDamage(true)}>Add damages</button>
              <button onClick={() => setOpenAddSales(true)}>
                {" "}
                <BsPercent /> Add Sales
              </button>
            </div>
          </div>

          {/* color tag */}
          <div className='colorTagDiv'>
            {product.colorApplicability && product.selectedColors.map((color, index) => <ColorTag key={index} color={color} />)}
          </div>
          {/* size tag */}
          <div className='colorTagDiv'>{product.sizeApplicability && product.selectedSizes.map((size, index) => <SizeTag key={index} size={size} />)}</div>
          <div className='BarcodeProducID'>
            {" "}
            {/*  */}
            <GeneratBarcode value={product.scannedID} />
          </div>
        </div>
        <div className='stockdetailMainWrapper2'>
          <div className='ProdHistory'>
            <h5
              style={{
                marginBottom: "18px",
              }}
            >
              History
            </h5>
            {/* 
            <div className='dateActivity'>
              <h5>Date</h5>
              <h5>Activity</h5>
            </div> */}

            {/*  {product.history
              .slice(0)
              .reverse()
              .map((history, index) => (
                <div key={index} className='activityConttentPD'>
                  <span>{new Date(history.date).toISOString().split("T")[0]}</span>
                  <div>
                    {history.activity.map((activity, i) => (
                      <p key={i}> {activity}</p>
                    ))}
                  </div>
                </div>
              ))} */}

            <ProductHistoryMain history={product.history} />
          </div>
          <div>
            <DoughnutChart
              value={[
                ["Instore", "in warehouse", "damaged"],
                [
                  product.damagedAmount ? product.quantity - product.damagedAmount : product.quantity,
                  product.amountInWarehouse ? product.amountInWarehouse : 0,
                  product.damagedAmount ? product.damagedAmount : 0,
                ],
              ]}
              confiq={{ title: "Quantity of Product available in Different Locations" }}
            />
            {chartData && <LineChartPD chartData={chartData} />}
            <div className='downloadPHistory'>
              <button onClick={() => setOpenViewHistory(true)}>View All History</button>
              <button className='movebtnProductdetail' onClick={() => setOpenMove(true)}>
                <Move size={20} color='#ffffff' />
                Move
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className='mobileShowChar3333'>
        <div className='mobileShowChar9999'>
          <DoughnutChart
            value={[
              ["Instore", "in warehouse", "damaged"],
              [
                product.damagedAmount ? product.quantity - product.damagedAmount : product.quantity,
                product.amountInWarehouse ? product.amountInWarehouse : 0,
                product.damagedAmount ? product.damagedAmount : 0,
              ],
            ]}
            confiq={{ title: "Quantity of Product available in Different Locations" }}
          />
          {chartData && <LineChartPD chartData={chartData} />}
        </div>
        <div className='downloadPHistory'>
          <button onClick={() => setOpenViewHistory(true)}>View History</button>
          <button className='movebtnProductdetail' onClick={() => setOpenMove(true)}>
            <Move size={20} color='#ffffff' />
            Move
          </button>
        </div>
      </div>
      {openViewHistory && <ProductHistory product={product} closeModal={setOpenViewHistory} storeID={store._id} />}
      {showPrintModal && <PrintLabelModal product={product} onClose={() => setShowPrintModal(false)} onConfirm={handlePrint} />}
      {openAddSales && (
        <AddSales
          closeModal={setOpenAddSales}
          changePage={changePage}
          product={product}
          storeID={store._id}
          currency={user.userCountryCurrencySymbol}
          updateSelectedProduct={updateSelectedProduct}
          storeName={store.storeName}
        />
      )}
      {openAddDamage && (
        <AddDamages
          closeModal={setOpenAddDamage}
          product={product}
          storeID={store._id}
          updateSelectedProduct={updateSelectedProduct}
          storeName={store.storeName}
        />
      )}
      {openConfirmPassword && (
        <ConfirmPassword
          closeModal={setOpenConfirmPassword}
          task={productEditOrDelete}
          setAlertDisplay={setAlertDisplay}
          product={product}
          storeID={store._id}
          updateSelectedProduct={updateSelectedProduct}
          handleDelete={handleDelete}
          setTask={setProductEditOrDelete}
          changePage={changePage}
          socket={socket}
        />
      )}
      {openRestockModal && (
        <RestockOverlay product={product} closeModal={setOpenRestockModal} warehouse={false} updateSelectedProduct={updateSelectedProduct} />
      )}
      {addSubUnit && (
        <SubUnitOverlay
          productToEdit={product}
          closeModal={() => setAddSubUnit(false)}
          updateSelectedProduct={updateSelectedProduct}
          storeID={store._id}
          storeName={store.storeName}
          currency={user.userCountryCurrencySymbol}
        />
      )}

      {viewSubUnit && product.hasSubUnits && (
        <StockBreakdownOverlay
          viewSubUnit={viewSubUnit}
          closeSubUnitView={() => {
            setViewSubUnit(false);
          }}
          product={reshapeProductData(product)}
          currency={user.userCountryCurrencySymbol}
          updateSelectedProduct={updateSelectedProduct}
          storeName={store.storeName}
        />
      )}

      {openMove && (
        <MoveProductFromStoreOverlay
          product={product}
          onClose={() => setOpenMove(false)}
          updateSelectedProduct={updateSelectedProduct}
          sourceType='store'
          sourceID={store._id}
          currency={user.userCountryCurrencySymbol || ""}
          onMove={() => {
            console.log("product moved");
          }}
        />
      )}
    </>
  );
};

export default StockDetails;

const reshapeProductData = (productData) => {
  const reshapedProduct = {
    _id: productData._id,
    storeID: productData.storeID,
    name: productData.name,
    baseUnit: productData.unit,
    baseQty: productData.quantity,
    subUnits: productData.subUnits
      ? productData.subUnits.map((subUnit) => ({
          id: subUnit.id,
          name: subUnit.name,
          perBase: subUnit.conversionFactor,
          price: subUnit.sellingPrice,
          qty: subUnit.quantityOfSubUnitInStock,
        }))
      : [],
  };
  return reshapedProduct;
};

let imagePlaceholder = "https://res.cloudinary.com/ebuka1122/image/upload/v1746897856/static%20images%20storelens/download_bvjych.png";

// function to convert image to blob
const convertToBlob = async (imageUrl) => {
  try {
    const response = await fetch(imageUrl);
    if (!response.ok) {
      throw new Error(`Failed to fetch ${imageUrl}: ${response.status}`);
    }
    const blob = await response.blob();
    return blob;
  } catch (error) {
    console.error("Error converting image to blob:", error);
  }
};

const ConfirmPassword = ({ closeModal, task, setAlertDisplay, product, storeID, updateSelectedProduct, setTask, changePage, socket }) => {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [isStockLimitLessThanQuantity, setIsStockLimitLessThanQuantity] = useState(true);
  const [isCostPricelessThanUnitPrice, setIsCostPricelessThanUnitPrice] = useState(true);
  const [selectedSize, setSelectedSize] = useState(product.selectedSizes ? product.selectedSizes : null);
  const [size, setSize] = useState(product.sizeApplicability ? product.sizeApplicability : false);
  const [openSizeModal, setOpenSizeModal] = useState(false);
  const [isColorApplicable, setIsColorApplicable] = useState(product.colorApplicability ? product.colorApplicability : false);
  const [openColorModal, setOpenColorModal] = useState(false);
  const [selectedColor, setSelectedColor] = useState(product.selectedColors ? product.selectedColors : null);
  const [canDeliver, setCanDeliver] = useState(product.canBeDelivered ? product.canBeDelivered : false);
  const [openScannerWindow, setOpenScannerWindow] = useState(false);
  const [scannedID, setScannedID] = useState(product.scannedID ? product.scannedID : null);
  const [productData, setProductData] = useState({
    name: product.name,
    brand: product.brand,
    productCategory: product.productCategory,
    productState: product.productState,
    unit: product.unit,
    quantity: product.quantity,
    stockLimit: product.stockLimit,
    costPrice: product.costPrice,
    unitPrice: product.unitPrice,
    productDescription: product.productDescription,
    deliveryTime: product.deliveryTime ? product.deliveryTime : null,
    deliveryFee: product.deliveryFee ? product.deliveryFee : null,
  });
  const [productImages, setProductImages] = useState(product.productImage ? product.productImage : []);
  const [productImageStage, setProductImageStage] = useState(null);
  const [productBuffer, setProductBuffer] = useState([]); // blob instance
  const [productBufferStage, setProductBufferStage] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);
  const [missingFields, setMissingFields] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [takeImageWithPhone, setTakeImageWithPhone] = useState(false);
  const [isImageCropperOpen, setIsImageCropperOpen] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [hasFormBeenEdited, setHasFormBeenEdited] = useState(false);

  const { store } = useSelector((state) => state.store);
  const { user } = useSelector((state) => state.webStoreUser);

  const unWantedInputs = ["+", "-", "e", "E", " "];
  const barcodeRef = useRef(null);
  // remove after

  useEffect(() => {
    console.log("user", user);

    if (user.email === "elinauloma@gmail.com" && task !== "delete") {
      openEditPanel();
    }
  }, []);

  // convert each image to blob
  useEffect(() => {
    if (product.productImage?.length > 0) {
      (async () => {
        const blobs = await Promise.all(product.productImage.map((url) => convertToBlob(url)));
        setProductBuffer(blobs);
      })();
    }
  }, [product]);

  // 1) Capture the very first “snapshot” of all the inputs
  //    so we can compare it to the current state later
  const initialSnapshot = useRef({
    data: productData,
    deliver: canDeliver,
    isColorApplicable: isColorApplicable,
    isSizeApplicable: size,
    selectedSize: selectedSize,
    selectedColor: selectedColor,
  });

  // refs to track “did we already run the first time?”
  const hasSizeEffectRun = useRef(false);
  const hasColorEffectRun = useRef(false);
  const hasProductDataEffectRun = useRef(false);
  const hasProductImageEffectRun = useRef(false);
  const dispatch = useDispatch();
  const isMobileDevice = /Mobi|Android/i.test(navigator.userAgent);

  // effect to check if the product image has been uploaded or changed
  useEffect(() => {
    if (!hasProductImageEffectRun.current) {
      // mark that we’ve now run once, but don’t do the body

      hasProductImageEffectRun.current = true;
      return;
    }
    setHasFormBeenEdited(true);
  }, [productImages]);

  useEffect(() => {
    let missing = [];

    // necessary to skip first render
    if (!hasProductDataEffectRun.current) {
      // mark that we’ve now run once, but don’t do the body
      hasProductDataEffectRun.current = true;
      return;
    }

    // on any change compare current and initial
    const unchanged =
      JSON.stringify(productData) === JSON.stringify(initialSnapshot.current.data) &&
      canDeliver === initialSnapshot.current.deliver &&
      size === initialSnapshot.current.isSizeApplicable &&
      isColorApplicable === initialSnapshot.current.isColorApplicable &&
      selectedSize === initialSnapshot.current.selectedSize &&
      selectedColor === initialSnapshot.current.selectedColor;

    // 2) If changed, mark as edited

    if (unchanged) {
      console.log("unchanged", unchanged);

      setHasFormBeenEdited(false);
    } else {
      console.log("changed", unchanged);
      setHasFormBeenEdited(true);
    }

    // 1) Product buffer is empty, means no image uploaded
    if (productBuffer.length === 0) {
      missing.push("Product image");
    }

    // 2) map and populate the missing fields
    Object.entries(productData).forEach(([key, value]) => {
      if (value === "" || value === NaN || value === "<p><br></p>") {
        missing.push(key);
      } else {
        missing = missing.filter((item) => item !== key);
      }
    });

    // 3) If not deliverable, drop the two delivery fields from missing
    if (!canDeliver) {
      // e.g. assume 'deliveryFee' and 'deliveryTime' aren’t required
      missing = missing.filter((key) => key !== "deliveryFee" && key !== "deliveryTime");
    }

    /*  if (canDeliver && missingFields.length === 0 && productBuffer.length > 0) {
      setIsFormValid(true);
    } else if (!canDeliver && missingFields.length === 0 && productBuffer.length > 0) {
      setIsFormValid(true);
    } else {
      console.log("not valid");
      setIsFormValid(false);
    } */

    // 4) Sync the missingFields state once

    setMissingFields(missing);
  }, [productData, productBuffer, canDeliver, size, isColorApplicable, selectedSize, selectedColor]);

  useEffect(() => {
    if (canDeliver && missingFields.length === 0 && productBuffer.length > 0) {
      setIsFormValid(true);
    } else if (!canDeliver && missingFields.length === 0 && productBuffer.length > 0) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [missingFields]);

  // effect to update the barcode
  useEffect(() => {
    if (barcodeRef.current) {
      JsBarcode(barcodeRef.current, scannedID, {
        format: "CODE128",
        displayValue: true,
        width: 2,
        height: 30,
        margin: 0,
        fontSize: 10,
      });
    }
  }, [scannedID]);

  // effect to check if size is applicable and open the modal to set size
  useEffect(() => {
    if (!hasSizeEffectRun.current) {
      // mark that we’ve now run once, but don’t do the body
      hasSizeEffectRun.current = true;
      return;
    }
    if (size) {
      setOpenSizeModal(true);
    } else {
      setOpenSizeModal(false);
      setSelectedSize(null);
    }
  }, [size]);

  // effect to check if color is applicable and open the modal to set colors
  useEffect(() => {
    if (!hasColorEffectRun.current) {
      hasColorEffectRun.current = true;
      return;
    }

    /* check if color is applicable */
    if (isColorApplicable) {
      setOpenColorModal(true);
    } else {
      setOpenColorModal(false);
      setSelectedColor(null);
    }
  }, [isColorApplicable]);

  // effect to check unit price and cost price
  useEffect(() => {
    if (productData.unitPrice && productData.costPrice && parseInt(productData.costPrice) >= parseInt(productData.unitPrice)) {
      setIsCostPricelessThanUnitPrice(false);
    } else {
      setIsCostPricelessThanUnitPrice(true);
    }
  }, [productData.unitPrice, productData.costPrice]);
  // effect to check unit price and cost price
  useEffect(() => {
    if (productData.quantity && productData.stockLimit && Number(productData.stockLimit) > Number(productData.quantity)) {
      setIsStockLimitLessThanQuantity(false);
    } else {
      setIsStockLimitLessThanQuantity(true);
    }
  }, [productData.quantity, productData.stockLimit]);

  // delete product and update the store product collection on IndexDB
  const handleDelete = async () => {
    setLoading(true);
    let accessToken = localStorage.getItem("accessToken");
    let storeID = store._id;
    let productID = product._id;

    try {
      let response = await fetch(createProductUrl + storeID, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ productID, password }),
      });
      if (response.ok) {
        uiAlert("product deleted successfully", "success");
        let { savedProductCollection, user } = await response.json();

        let storeData = await getAllData(store.storeName);

        if (storeData) {
          storeData.storeProductCollection = savedProductCollection.products;

          await saveData(store.storeName, storeData);

          dispatch(setUser(user));

          changePage("stockManagement");
        }
        uiAlert("product deleted successfully", "success");
        changePage("stockManagement");
      } else if (response.status === 404) {
        uiAlert("password is incorrect, try again", "error");

        setPassword("");
        return;
      }
    } catch (error) {
      console.log(error);
      uiAlert("something went wrong, try again", "error");
    } finally {
      setLoading(false);
    }
  };

  //confirm password for edit
  const confirmPassword = async () => {
    setLoading(true);
    let accessToken = localStorage.getItem("accessToken");
    let storeID = store._id;

    try {
      let response = await fetch(confirmPasswordUrl + storeID, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ password }),
      });

      if (response.ok) {
        return openEditPanel();
      } else if (response.status === 404) {
        uiAlert("password is incorrect, try again", "error");

        setPassword("");
        return;
      }

      throw new Error("Failed to confirm password");
    } catch (error) {
      uiAlert("something went wrong, try again", "error");

      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // open edit product panel after password is confirmed
  const openEditPanel = async () => {
    let passwordNode = document.querySelector(".confirmPasswordDiv988");
    let editProductNode = document.querySelector(".editPasDi374653");

    passwordNode.style.transform = "translateX(-200%)";
    passwordNode.style.opacity = "0";
    passwordNode.addEventListener("transitionend", function onHide(e) {
      if (e.propertyName !== "transform") return; // only handle one end event
      passwordNode.style.display = "none";
      passwordNode.removeEventListener("transitionend", onHide);

      // 3) Prepare the edit panel “off-screen” to the right
      editProductNode.style.display = "flex";
      editProductNode.style.opacity = "0";
      editProductNode.style.transform = "translateX(200%)";

      // 4) Force a reflow so the browser registers the above styles
      //    before we trigger the slide-in
      /* eslint-disable no-unused-expressions */
      editProductNode.offsetHeight;
      /* eslint-enable no-unused-expressions */

      // 5) Slide in & fade the edit panel
      editProductNode.style.transform = "translateX(0)";
      editProductNode.style.opacity = "1";
    });
  };

  // open scanner window
  const setOpenScanner = () => {
    setOpenScannerWindow(true);
  };

  //handle and display image input
  const handleProductImageUpload = (e) => {
    setHasFormBeenEdited(true);
    let image = e.target.files[0];
    setProductBufferStage([...productBuffer, image]); /* irreleveant */

    if (image) {
      let reader = new FileReader();
      reader.onload = function (evt) {
        /* setProductImages([...productImages, evt.target.result]); */
        setProductImageStage(evt.target.result);

        setIsImageCropperOpen(true);
      };
      reader.readAsDataURL(image);
    } else {
      uiAlert("upload failed", "error");
    }
  };

  //upload image and get the image url
  const uploadImages = async () => {
    let accessToken = localStorage.getItem("accessToken");
    let formData = new FormData();
    productBuffer.forEach((image) => {
      formData.append("ProductImage", image);
    });

    try {
      let resp1 = await fetch(uploadProductImageUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });
      if (resp1.ok) {
        console.log("uploaded");
        let { imageUrl } = await resp1.json();
        return imageUrl;
      } else {
        uiAlert("upload failed", "error");
        return null;
      }
    } catch (error) {
      console.log(error);
    }
  };

  // handle edit

  const handleEdit = async () => {
    // check if missing inputs is filled
    if (missingFields.length > 0) {
      uiAlert("Please fill all the fields" + " " + missingFields.join(", "), "warning");
      return;
    }

    if (!isStockLimitLessThanQuantity) {
      uiAlert("Stock limit cannot be less than current quantity", "warning");
      return;
    }

    //upload image

    setIsLoading(true);
    let imageUrl = await uploadImages();

    let accessToken = localStorage.getItem("accessToken");

    // update product history
    let isCostPriceChanged = product.costPrice !== parseInt(productData.costPrice);
    let isUnitPriceChanged = product.unitPrice !== parseInt(productData.unitPrice);

    // check if quantity and stock limit are changed

    let isQuantityChanged = product.quantity !== Number(productData.quantity);
    let isStockLimitChanged = product.stockLimit !== Number(productData.stockLimit);

    // check if product has any history for current date
    let newHistory;
    let activityText;

    let index;
    let updateActivityforCurrentDate = product.history.find((history, index_) => {
      if (JSON.stringify(history.date).split("T")[0] === JSON.stringify(new Date()).split("T")[0]) {
        let text = `Product ${product.name} was edited by admin, ${
          isCostPriceChanged ? `Cost price was changed to ${user.userCountryCurrencySymbol}${productData.costPrice} ` : "Cost price was not changed"
        } and ${isUnitPriceChanged ? `Unit price was changed to ${user.userCountryCurrencySymbol}${productData.unitPrice} ` : `Unit price was not changed`}. ${
          isQuantityChanged ? `Also, quantity was changed from ${product.quantity} to ${productData.quantity} ` : ""
        } `;

        history.activity = [...history.activity, text];
        index = index_;
        activityText = text;
        return history;
      }
    });
    if (updateActivityforCurrentDate) {
      console.log("updateActivityforCurrentDate", updateActivityforCurrentDate);
      product.history[index] = updateActivityforCurrentDate;
      newHistory = product.history;
    } else {
      let text = `Product ${product.name} was edited by admin, ${
        isCostPriceChanged
          ? `Cost price was changed to ${user.userCountryCurrencySymbol}${productData.costPrice?.toLocaleString()} `
          : "Cost price was not changed"
      } and ${
        isUnitPriceChanged
          ? `Unit price was changed to ${user.userCountryCurrencySymbol}${productData.unitPrice?.toLocaleString()} `
          : `Unit price was not changed`
      }. ${isQuantityChanged ? `Also, quantity was changed from ${product.quantity} to ${productData.quantity} ` : ""} `;
      newHistory = [
        ...product.history,
        {
          date: new Date().toISOString(),
          activity: [text],
        },
      ];
      activityText = text;
    }
    console.log("newHistory", newHistory);

    //create product object
    let EditedProduct = {
      productID: product._id,
      name: productData.name,
      brand: productData.brand,
      productCategory: productData.productCategory,
      unit: productData.unit,
      stockLimit: parseInt(productData.stockLimit),
      quantity: parseInt(productData.quantity),
      costPrice: parseInt(productData.costPrice),
      unitPrice: parseInt(productData.unitPrice),
      productDescription: productData.productDescription,
      canBeDelivered: canDeliver,
      deliveryTime: canDeliver ? productData.deliveryTime : null,
      deliveryFee: canDeliver ? productData.deliveryFee : null,
      imageUrl: imageUrl,
      sizeApplicability: size,
      selectedSizes: selectedSize ? selectedSize.map((size) => (size.code ? size.code : size)) : null,
      colorApplicability: isColorApplicable,
      selectedColors: selectedColor ? selectedColor.map((color) => (color.name ? color.name : color)) : null,

      scannedID: scannedID ? scannedID : generateNumericId(),

      history: newHistory,
      activityText,
    };
    console.log(EditedProduct, "EditedProduct");

    try {
      let response = await fetch(editProductUrl + storeID, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(EditedProduct),
      });

      if (!response.ok) {
        throw new Error("Failed to edit product");
      }

      if (response.ok) {
        let { storeProductCollection, modifiedProduct } = await response.json();
        updateSelectedProduct(modifiedProduct);
        let storeData = await getAllData(store.storeName);
        if (storeData) {
          storeData.storeProductCollection = storeProductCollection.products;
          await saveData(store.storeName, storeData);

          /* setAlertDisplay({ display: true, message: "product edited successfully", type: "success" }); */
          //close modal
          uiAlert("Product edited successfully", "success");
          closeModal(false);
        }
      }
    } catch (error) {
      console.log(error);
      uiAlert("Something went wrong, product couldn't be edited, try again", "error");
      return;
    } finally {
      setIsLoading(false);
    }
  };

  const allowDigits = (e) => {
    if (e.inputType?.startsWith("insert") && e.data && /[^0-9]/.test(e.data)) {
      e.preventDefault();
    }
  };
  return (
    <>
      <div onClick={() => closeModal(false)} className='confirmPasswordWrapper'>
        {task === "delete" ? (
          <div onClick={(e) => e.stopPropagation()} className='confirmPasswordDiv988'>
            {/* confirm passwaod */}
            <h3>Enter password</h3>
            <input
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleDelete();
                }
              }}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className='DePas7364'
              type='password'
              placeholder='password'
            />

            {password ? (
              loading ? (
                <button>
                  {" "}
                  <ButtonLoader />{" "}
                </button>
              ) : (
                <button onClick={handleDelete}>Confirm and delete</button>
              )
            ) : (
              <button style={{ opacity: "0.7", cursor: "not-allowed" }}>Confirm and delete</button>
            )}
          </div>
        ) : (
          <>
            <div onClick={(e) => e.stopPropagation()} className='confirmPasswordDiv988'>
              {/* confirm passwaod */}
              <h3>Enter password</h3>
              <input
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    confirmPassword();
                  }
                }}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className='DePas7364'
                type='password'
                placeholder='password'
              />

              {password ? (
                loading ? (
                  <button>
                    {" "}
                    <ButtonLoader />{" "}
                  </button>
                ) : (
                  <button style={{ backgroundColor: "#0E49B5" }} onClick={confirmPassword}>
                    Confirm password
                  </button>
                )
              ) : (
                <button style={{ opacity: "0.7", cursor: "not-allowed", backgroundColor: "#0E49B5" }}>Confirm password</button>
              )}
            </div>
            <div onClick={(e) => e.stopPropagation()} className='editPasDi374653'>
              {" "}
              <div className='editPr9465s'>
                <div onClick={() => closeModal(false)}>
                  <BsArrowBarLeft size={20} />
                </div>
                <h3>Edit product</h3>
                {hasFormBeenEdited &&
                  (isFormValid ? (
                    isLoading ? (
                      <button style={{ opacity: "0.7" }}>
                        <ButtonLoader />
                      </button>
                    ) : (
                      <button onClick={handleEdit}>Save</button>
                    )
                  ) : (
                    <button
                      onClick={() => {
                        uiAlert("Please fill all the fields" + " " + missingFields.join(", "), "warning");
                      }}
                      style={{ opacity: "0.7" }}
                    >
                      Save
                    </button>
                  ))}
              </div>
              <div className='ed45odjD'>
                <div>
                  <h4 className='pEdiImag36'>Product Identity</h4>
                  <div style={{ padding: "0px 10px 10px 10px" }}>
                    <div className='productImageE9373'>
                      <img src={!productImages?.length == 0 ? productImages[0] : imagePlaceholder} alt='productImage' />
                      <img src={productImages?.length > 1 ? productImages[1] : imagePlaceholder} alt='productImage' />
                      <img src={productImages?.length > 2 ? productImages[2] : imagePlaceholder} alt='productImage' />
                      <img src={productImages?.length > 3 ? productImages[3] : imagePlaceholder} alt='productImage' />
                    </div>
                    <div style={{ width: "100%", position: "relative" }}>
                      <img className='laImEPiry66' src={!productImages?.length == 0 ? productImages[0] : imagePlaceholder} alt='productImage' />
                      <button
                        onClick={() => {
                          setProductImages([]);

                          setProductBuffer([]);
                        }}
                      >
                        Remove All
                      </button>
                    </div>
                    <div className='btnDIv7453'>
                      <button className='upIma36geg'>
                        <BsUpload size={15} /> Change image
                        {productImages.length < 4 && <input onChange={(e) => handleProductImageUpload(e)} type='file' accept='image/*' />}
                      </button>
                      {!isMobileDevice && (
                        <button onClick={() => productImages.length < 4 && setTakeImageWithPhone(true)}>
                          <BsPhone size={15} /> Use phone
                        </button>
                      )}
                    </div>

                    {/* product names */}
                    <div style={{ marginBottom: "16px" }}>
                      <p className='pText9475L'>Product name</p>
                      <input
                        maxLength={99}
                        value={productData.name}
                        onChange={(e) => setProductData({ ...productData, name: e.target.value })}
                        type={"text"}
                        required={true}
                        placeholder=' Enter product name'
                      />
                    </div>
                    <div style={{ marginBottom: "16px" }}>
                      <p className='pText9475L'>Brand</p>
                      <input
                        maxLength={20}
                        value={productData.brand}
                        onChange={(e) => setProductData({ ...productData, brand: e.target.value })}
                        type={"text"}
                        required={true}
                        placeholder=' Enter product brand'
                      />
                    </div>
                    <div style={{ marginBottom: "16px" }}>
                      <p className='pText9475L'>Category</p>
                      <select value={productData.productCategory} onChange={(e) => setProductData({ ...productData, productCategory: e.target.value })}>
                        <option value='' disabled selected hidden>
                          Choose category
                        </option>
                        {listOfProductCategory.map((category, i) => (
                          <option key={i}>{category}</option>
                        ))}
                        <option>Others</option>
                      </select>
                    </div>
                    <div>
                      <p className='pText9475L'>Stock limit</p>
                      <input
                        value={productData.stockLimit}
                        pattern={isMobileDevice ? "[0-9]*" : undefined}
                        type={isMobileDevice ? "text" : "number"}
                        inputMode='numeric' // shows numeric keyboard on mobile
                        onBeforeInput={isMobileDevice ? allowDigits : undefined}
                        placeholder=' Update stock limit'
                        onChange={(e) => {
                          const { value } = e.target;
                          // if the field is empty, keep it empty (so the user can delete all digits)

                          if (value === "") {
                            setProductData({ ...productData, stockLimit: "" });
                            return;
                          }

                          // parseInt with an explicit radix, and guard against NaN
                          const parsed = Number(value);
                          setProductData({ ...productData, stockLimit: Number.isNaN(parsed) ? productData.stockLimit : parsed });

                          setIsStockLimitLessThanQuantity(Number(value) <= Number(productData.quantity));
                        }}
                        onBlur={(e) => {
                          //if stock limit is "" reset to previous value
                          if (e.target.value === "") {
                            setProductData({ ...productData, stockLimit: product.stockLimit });
                          }
                        }}
                      />
                      {!isStockLimitLessThanQuantity && <span className='pricing-error-text-st123'>Stock limit cannot be higher than quantity</span>}
                    </div>
                  </div>
                </div>
                <div>
                  <h4 className='pEdiImag36'>Product information</h4>
                  <div style={{ padding: "10px" }}>
                    <div className='eacTak76h'>
                      <div>
                        <p className='pText9475L'>Product unit</p>
                        <select value={productData.unit} onChange={(e) => setProductData({ ...productData, unit: e.target.value })}>
                          <option value='' disabled selected hidden>
                            Select unit
                          </option>
                          {productUnit.map((unit) => (
                            <option>{unit}</option>
                          ))}
                          <option>Others</option>
                        </select>
                      </div>
                      <div>
                        <p className='pText9475L'>
                          Cost price <b>{user.userCountryCurrencySymbol} </b>{" "}
                        </p>
                        <input
                          key={isMobileDevice ? "mobile" : "desktop"}
                          pattern={isMobileDevice ? "[0-9]*" : undefined}
                          type={isMobileDevice ? "text" : "number"}
                          inputMode='numeric' // shows numeric keyboard on mobile
                          onBeforeInput={isMobileDevice ? allowDigits : undefined}
                          value={productData.costPrice}
                          onKeyDown={(e) => {
                            if (unWantedInputs.includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            const { value } = e.target;
                            // if the field is empty, keep it empty (so the user can delete all digits)

                            if (value === "") {
                              setProductData({ ...productData, costPrice: "" });
                              return;
                            }

                            // parseInt with an explicit radix, and guard against NaN
                            const parsed = Number(value);
                            setProductData({ ...productData, costPrice: Number.isNaN(parsed) ? productData.costPrice : parsed });
                          }}
                          required={true}
                          placeholder=' Update cost price'
                        />
                      </div>
                    </div>
                    <div className='eacTak76h'>
                      <div>
                        <p className='pText9475L'>Quantity</p>
                        <input
                          value={productData.quantity}
                          pattern={isMobileDevice ? "[0-9]*" : undefined}
                          type={isMobileDevice ? "text" : "number"}
                          inputMode='numeric' // shows numeric keyboard on mobile
                          onBeforeInput={isMobileDevice ? allowDigits : undefined}
                          placeholder=' Update stock limit'
                          onChange={(e) => {
                            const { value } = e.target;
                            // if the field is empty, keep it empty (so the user can delete all digits)

                            if (value === "") {
                              setProductData({ ...productData, quantity: "" });
                              return;
                            }

                            // parseInt with an explicit radix, and guard against NaN
                            const parsed = Number(value);
                            setProductData({ ...productData, quantity: Number.isNaN(parsed) ? productData.quantity : parsed });

                            setIsStockLimitLessThanQuantity(Number(product.stockLimit) <= Number(value));
                          }}
                          onBlur={(e) => {
                            //if stock limit is "" reset to previous value
                            if (e.target.value === "") {
                              setProductData({ ...productData, quantity: product.quantity });
                            }
                          }}
                        />
                        {!isStockLimitLessThanQuantity && <span className='pricing-error-text-st123'>Stock limit cannot be higher than quantity</span>}
                      </div>
                      <div>
                        <p className='pText9475L'>
                          Unit price <b>{user.userCountryCurrencySymbol} </b>{" "}
                        </p>
                        <input
                          value={productData.unitPrice}
                          onKeyDown={(e) => {
                            if (unWantedInputs.includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            const { value } = e.target;
                            // if the field is empty, keep it empty (so the user can delete all digits)

                            if (value === "") {
                              setProductData({ ...productData, unitPrice: "" });
                              return;
                            }

                            // parseInt with an explicit radix, and guard against NaN
                            const parsed = parseInt(value, 10);
                            setProductData({ ...productData, unitPrice: Number.isNaN(parsed) ? productData.unitPrice : parsed });
                          }}
                          type={"number"}
                          required={true}
                          placeholder=' Update unit price'
                        />
                        {!isCostPricelessThanUnitPrice && (
                          <p style={{ marginTop: "10px", display: "flex", gap: "4px" }} className='stockHighlightMesggaes22'>
                            {" "}
                            <BsInfo size={18} /> Warning: Unit price should more than Cost price to avoid negative margin
                          </p>
                        )}
                      </div>
                    </div>

                    <div className='dashline99'></div>
                    <div className='sizedescriptDeliv PEditRest374'>
                      <div>
                        <div className={size ? "sizedivdrwawer sizeTrue" : "sizedivdrwawer"}>
                          <div className='canbeDeliveredDIv'>
                            <p>Update product size</p>
                            <DeliverToggle key={1} toggleValue={size} updatetoggle={setSize} />
                          </div>
                          <div className='sizeContainer12'>{selectedSize && selectedSize.map((size) => <SizeTag size={size.code ? size.code : size} />)}</div>
                          <div className='canbeDeliveredDIv'>
                            <p> Update product colors</p>
                            <DeliverToggle key={2} toggleValue={isColorApplicable} updatetoggle={setIsColorApplicable} />
                          </div>
                          <div className='sizeContainer12'>
                            {selectedColor && selectedColor.map((color) => <ColorTag color={color.name ? color.name : color} />)}
                          </div>
                        </div>
                        <div>
                          <div className='canbeDeliveredDIv'>
                            <p> can item be purchased online?</p>
                            {/* <DeliverToggle key={3} toggleValue={canDeliver} updatetoggle={setCanDeliver} /> */}
                            <ProductDeliverToggle key={4} toggleValue={canDeliver} updatetoggle={setCanDeliver} removeDelivData={setProductData} />
                          </div>
                          <div className={canDeliver ? "deliveryDivSHake" : "deliveryDivSHake deShDHeigt"}>
                            <div>
                              <span>{user.userCountryCurrencySymbol}</span>
                              <input
                                value={productData.deliveryFee}
                                onKeyDown={(e) => {
                                  if (unWantedInputs.includes(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={(e) => {
                                  const { value } = e.target;
                                  // if the field is empty, keep it empty (so the user can delete all digits)

                                  if (value === "") {
                                    setProductData({ ...productData, deliveryFee: "" });
                                    return;
                                  }

                                  // parseInt with an explicit radix, and guard against NaN
                                  const parsed = parseInt(value, 10);
                                  setProductData({
                                    ...productData,
                                    deliveryFee: Number.isNaN(parsed) ? productData.deliveryFee : parsed,
                                  });
                                }}
                                className='deliveryParainput'
                                type='number'
                                placeholder='Delivery fee'
                              />
                            </div>
                            <span></span>
                            <div>
                              <input
                                value={productData.deliveryTime}
                                onKeyDown={(e) => {
                                  if (unWantedInputs.includes(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={(e) => {
                                  const { value } = e.target;
                                  // if the field is empty, keep it empty (so the user can delete all digits)

                                  if (value === "") {
                                    setProductData({ ...productData, deliveryTime: "" });
                                    return;
                                  }

                                  // parseInt with an explicit radix, and guard against NaN
                                  const parsed = parseInt(value, 10);
                                  setProductData({
                                    ...productData,
                                    deliveryTime: e.target.value > 4 ? 4 : Number.isNaN(parsed) ? productData.deliveryTime : parsed,
                                  });
                                }}
                                max={4}
                                min={1}
                                className='deliveryParainput'
                                type='number'
                                placeholder='Delivery time'
                              />
                              <span>days</span>
                            </div>
                          </div>
                        </div>
                        {!scannedID ? (
                          <button onClick={() => setOpenScanner()} className='scanBarCd22btn'>
                            <BsUpcScan size={20} />
                            Add barcode
                          </button>
                        ) : (
                          <div style={{ width: "100%", position: "relative" }}>
                            {" "}
                            <svg className='barcodeSVG' ref={barcodeRef} />
                            <p
                              onClick={() => {
                                setScannedID(null);
                              }}
                              className=''
                            >
                              X
                            </p>
                          </div>
                        )}
                      </div>
                      <div>
                        <ReactQuill
                          theme='snow'
                          value={productData.productDescription}
                          //onChange={(e) => setProductData({ ...productData, productDescription: e })}
                          onChange={(e) => setProductData({ ...productData, productDescription: e })}
                          className='productDescription pedEdi736'
                          modules={{
                            toolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }], , ["clean"]],
                          }}
                          placeholder={"Product description"}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      {openSizeModal && <Wishes closeModalWithSizeFalse={setSize} closeModalWithSizeTrue={setOpenSizeModal} updateSelectedSize={setSelectedSize} />}

      {openColorModal && (
        <WisheColor updateSelectedColor={setSelectedColor} closeModalWithColorTrue={setOpenColorModal} closeModalWithColorFalse={setIsColorApplicable} />
      )}
      {isLoading && <Spinner position={"fixed"} />}

      {takeImageWithPhone && (
        <UploadImageWithPhone
          setTakeImageWithPhone={setTakeImageWithPhone}
          store={store}
          socket={socket}
          setCroppedImageUrl={setProductImages}
          setCroppedImageBolb={setProductBuffer}
        />
      )}

      {isImageCropperOpen && (
        <ImageCropper
          readImageUrl={productImageStage}
          setCroppedImageUrl={setProductImages}
          setCroppedImageBolb={setProductBuffer}
          closeModal={setIsImageCropperOpen}
          borderRadius={4}
          isMultipleImage={true}
        />
      )}

      {
        openScannerWindow &&
          (isMobileDevice ? (
            <BarcodeScanner
              setScanCodeString={setScannedID}
              handleProductScan={() => {
                // do nothing
              }}
              setOpenScannerModal={setOpenScannerWindow}
              isCreatingProduct={false}
            />
          ) : (
            <ScannerWindow setOpenScannerWindow={setOpenScannerWindow} setScannedID={setScannedID} />
          )) /* <BarcodeScanner setScannedID={setScannedID} /> */
      }
    </>
  );
};

function PrintLabelModal({ product, onClose, onConfirm }) {
  const [qty, setQty] = useState(1);

  const change = (delta) => setQty((q) => Math.max(1, Math.min(500, q + delta)));
  const label = qty === 1 ? "Print 1 label" : `Print ${qty} labels`;

  return createPortal(
    <div className='pdp-overlay' onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div
        style={{
          background: "#fff",
          borderRadius: 14,
          border: "1px solid #e2e8f2",
          padding: "24px 28px",
          width: "100%",
          maxWidth: 400,
        }}
      >
        {/* Header */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div
              style={{
                width: 36,
                height: 36,
                borderRadius: 8,
                background: "#f0f4fa",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "20px",
              }}
            >
              🖨
            </div>
            <div>
              <div style={{ fontSize: 15, fontWeight: 800, color: "#1e3a5f" }}>Print label</div>
              <div style={{ fontSize: 11, color: "#6b7a99" }}>80mm thermal printer</div>
            </div>
          </div>
          <button className='pdp-icon-btn' onClick={onClose}>
            ✕
          </button>
        </div>

        {/* Product strip */}
        <div style={{ background: "#f7f9fd", borderRadius: 9, padding: "10px 14px", marginBottom: 20, display: "flex", gap: 10, alignItems: "center" }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#1e3a5f" }}>{product?.name}</div>
          {product?.scannedID && <div style={{ fontSize: 11, color: "#6b7a99" }}>SKU: {product.scannedID}</div>}
        </div>

        {/* Qty input */}
        <label style={{ fontSize: 12, fontWeight: 700, color: "#6b7a99", display: "block", marginBottom: 6 }}>Number of labels to print</label>
        <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
          <button className='pdp-icon-btn' onClick={() => change(-1)}>
            −
          </button>
          <input
            type='number'
            min={1}
            max={500}
            value={qty}
            onChange={(e) => setQty(Math.max(1, Math.min(500, +e.target.value || 1)))}
            style={{
              flex: 1,
              textAlign: "center",
              fontSize: 20,
              fontWeight: 800,
              color: "#1e3a5f",
              border: "1px solid #e2e8f2",
              borderRadius: 8,
              padding: "6px 0",
            }}
          />
          <button className='pdp-icon-btn' onClick={() => change(1)}>
            +
          </button>
        </div>

        {/* Quick picks */}
        <div style={{ display: "flex", gap: 6, marginBottom: 16, flexWrap: "wrap", alignItems: "center" }}>
          <span style={{ fontSize: 11, color: "#6b7a99" }}>Quick:</span>
          {[5, 10, 20, 50, 100].map((n) => (
            <button
              key={n}
              onClick={() => setQty(n)}
              style={{
                padding: "3px 10px",
                borderRadius: 6,
                border: "1px solid #e2e8f2",
                background: qty === n ? "#1e3a5f" : "#fff",
                color: qty === n ? "#fff" : "#1e3a5f",
                fontSize: 12,
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              {n}
            </button>
          ))}
        </div>

        {/* Preview */}
        <div style={{ background: "#f7f9fd", borderRadius: 9, padding: "9px 14px", marginBottom: 20, display: "flex", justifyContent: "space-between" }}>
          <span style={{ fontSize: 12, color: "#6b7a99" }}>Will print</span>
          <span style={{ fontSize: 13, fontWeight: 800, color: "#1e3a5f" }}>{qty === 1 ? "1 label" : `${qty} labels`}</span>
        </div>

        {/* Actions */}
        <div style={{ display: "flex", gap: 8 }}>
          <button className='pdp-cta-btn pdp-cta-outline' onClick={onClose}>
            Cancel
          </button>
          <button className='pdp-cta-btn pdp-cta-solid' style={{ flex: 2 }} onClick={() => onConfirm(qty)}>
            🖨 {label}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
